import { RouteName } from '@/router/route-names';
import NewAccount from '@/shared/components/pages/NewAccount.vue';
import AccessDeniedPage from '@/shared/components/AccessDeniedPage.vue';
import { store } from '@/store';
import noop from 'lodash/noop';
import NotLoggedInEmbed from '@/shared/components/pages/NotLoggedInEmbed.vue';
import { auth, performLogout } from '@/plugins/auth';
import { isEmbedded } from '@/play-editor/frame';

import ErrorPage from '@/shared/components/pages/ErrorPage.vue';
import { RouteRecordRaw } from 'vue-router';
import NestedRouter from '@/router/NestedRouter.vue';

const AuthErrorPage = () => import('@/shared/components/AuthErrorPage.vue');

export const authRoutes: RouteRecordRaw[] = [
    { path: '/new', component: NewAccount },
    {
        path: '/loggedout',
        name: RouteName.loggedOut,
        meta: {
            title: 'routes.loggedOut',
            isPublic: true,
        },
        component: NestedRouter,
        beforeEnter: () => {
            if (isEmbedded()) {
                return { name: RouteName.loggedOutEmbed, replace: true };
            }

            if (auth) {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                auth.loginWithRedirect({
                    appState: { target: '/' },
                });
            }

            return false;
        },
    },
    {
        path: '/error',
        name: RouteName.error,
        meta: {
            title: 'routes.error',
            isPublic: true,
        },
        component: ErrorPage,
    },
    {
        path: '/loggedoutEmbed',
        name: RouteName.loggedOutEmbed,
        meta: {
            isPublic: true,
        },
        component: NotLoggedInEmbed,
    },
    {
        path: '/access-denied',
        name: RouteName.accessDenied,
        component: AccessDeniedPage,
        meta: {
            title: 'routes.accessDenied',
            isPublic: true,
        },
    },
    {
        path: '/auth-error',
        name: RouteName.authError,
        component: AuthErrorPage,
        meta: {
            title: 'routes.authError',
            isPublic: true,
        },
    },
    {
        path: '/logout',
        name: RouteName.logout,
        meta: {
            title: 'routes.logout',
            isPublic: true,
        },
        component: NestedRouter,
        beforeEnter: () => {
            // noinspection JSIgnoredPromiseFromCall
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            store.dispatch('auth/LOGOUT').then(noop);

            if (!isEmbedded()) {
                performLogout();
            }

            return false;
        },
    },

];
